import { Cookies } from "@grandvisionhq/lib-cookies";
import { useFeatureToggles } from "@grandvisionhq/state";
const useGetPriceSegment = () => {
  const {
    featureConfigs: { priceSegmentQueryKey }
  } = useFeatureToggles();
  const priceSegment = priceSegmentQueryKey && Cookies.get(priceSegmentQueryKey ?? "");
  return { priceSegment };
};
export {
  useGetPriceSegment
};
//# sourceMappingURL=use-get-price-segment.js.map
